<template>
    <div>
        <e-dialog
                dialogType="other"
                dialogTitle="易派客提醒您"
                buttonTip="我知道了"
                :isShowCancel="isShowCancel"
                :centerDialogVisible="whetherPayOnlineVisible"
                @resetPopupData="resetPopupData"
                @submitPopupData="resetPopupData"
                :popupWidth="'420px'">
            <div>产品质量评价费用，需使用易派客在线支付功能，请您先办理开通!
              <span class="to-open margin-l20" @click="toPass">开通易派客支付</span>
            </div>
        </e-dialog>
    </div>
    
</template>

<script>
    import eDialog from "../../../components/common/e-dialog.vue";
    export default {
        name: "whetherPayOnline",
        components:{eDialog},
        props:{
            whetherPayOnlineVisible:Boolean
        },
      data(){
          return{
            isShowCancel:false,
          }
      },
        methods:{
          toPass(){
            this.$router.push({
              path: '/paymentAccount'
            })
          },
            resetPopupData(){
              this.$emit('closeDialog');
            },
        },
    }
</script>

<style scoped lang="scss">
.to-open{
  color: #2d8cf0;
  cursor: pointer;
}
</style>
